import React from 'react';
import styled from 'styled-components';
import EventModal from '../main/components/EventModal';
import AIChatModal from './AIChatModal';

interface Props {
  openModal: boolean;
  openChatModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  setOpenChatModal: (openModal: boolean) => void;
}

function PopupBanner({
  openModal,
  openChatModal,
  setOpenModal,
  setOpenChatModal,
}: Props) {
  return (
    <Container>
      <Inner>
        {openChatModal && <AIChatModal setOpenChatModal={setOpenChatModal} />}
        {openModal && <EventModal setOpenModal={setOpenModal} />}
      </Inner>
    </Container>
  );
}

export default PopupBanner;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 900px;
  margin: 0 auto;
`;
